// Application-wide constants
export const APP_CONFIG = {
  // Pagination
  ITEMS_PER_PAGE: 10,
  
  // Search and filters
  MAX_RECENT_SEARCHES: 4,
  DEFAULT_COTATION_RANGE: {
    MIN: 0,
    MAX: 100
  },
  
  // UI behavior
  TOAST_DURATION: {
    DEFAULT: 5000,
    SUCCESS: 3000,
    ERROR: 8000,
    WARNING: 6000
  },
  
  // Animation
  ANIMATION_DELAYS: {
    CARD_STAGGER: 50,
    SKELETON_STAGGER: 100
  },
  
  // Virtualization
  VIRTUALIZATION: {
    OVERSCAN: 5
  },
  
  // Patient calculation
  PATIENT_LIMITS: {
    MIN: 1,
    MAX: 30
  },
  
  // Pagination display
  MAX_VISIBLE_PAGES: 5,
  
  // Share dropdown
  SHARE_DROPDOWN_WIDTH: 'w-48',
  SHARE_DROPDOWN_Z_INDEX: 'z-[99999]',
  
  // Copy feedback duration
  COPY_FEEDBACK_DURATION: 2000
} as const;

// Filter options
export const FILTER_OPTIONS = {
  REFERENTIEL: [
    { value: 'all', label: 'Tous' },
    { value: 'true', label: 'Soumis au référentiel' },
    { value: 'false', label: 'Hors référentiel' }
  ]
} as const;

// Search suggestions
export const SEARCH_SUGGESTIONS = [
  'AMK 7.3',
  'AMS 9.5', 
  'AMC 4.5',
  'Massage',
  'Rééducation motrice',
  'Drainage lymphatique',
  'Mobilisation articulaire',
  'Étirement'
] as const;

// Display limits
export const DISPLAY_LIMITS = {
  SUGGESTIONS: 5,
  RECENT_SEARCHES: 3,
  SKELETON_CARDS: 6
} as const;

// Application information
export const APP_INFO = {
  BASE_URL: 'https://ngap-kine.fr',
  SHORT_TITLE: 'NGAP Kiné',
  TITLE: 'NGAP Kiné - Simulateur de cotations kinésithérapie | Tarifs 2026',
  DESCRIPTION: 'Simulateur officiel des cotations NGAP pour kinésithérapeutes. Calculez vos tarifs, consultez les revalorisations 2026-2027 et optimisez vos consultations.',
  BANNER_IMAGE: 'https://ngap-kine.fr/banner-ngap-kine.png',
  LOGO_IMAGE: 'https://ngap-kine.fr/logo-appines.png'
} as const;

// Popup dimensions for social sharing
export const POPUP_DIMENSIONS = {
  WIDTH: 600,
  HEIGHT: 400
} as const;